<mat-card class="create-rule">
  <mat-card-title class="create-rule__title-wrapper">
    <button class="create-rule__action-button" mat-icon-button (click)="onClickRule()">
      @if (scheduleService()?.isRuleExpanded?.[index()]) {
        <mat-icon id="keyboard-arrow-down">keyboard_arrow_down</mat-icon>
      }
      @if (!scheduleService()?.isRuleExpanded?.[index()]) {
        <mat-icon>keyboard_arrow_right</mat-icon>
      }
    </button>
    <div
      class="create-rule__title--with-icon"
      (click)="!scheduleService()?.isRuleExpanded?.[index()] ? onClickRule() : undefined"
    >
      <mat-icon>list_alt</mat-icon>
      Rule {{ order() + 1 }}
    </div>
    <div class="create-rule__header-groups">
      @if (scheduleService()?.isRuleExpanded?.[index()]) {
        <vectronic-header-group>
          <vectronic-header-item
            label="Duration"
            headerTooltip="Rule run time"
            [value]="getDurationString()"
            [readonly]="readonly()"
            [noEllipsis]="true"
          >
            <vectronic-header-field
              type="radio"
              [options]="TIME_TYPE_OPTIONS"
              [control]="timeTypeFormControl"
              (valueChange)="onTimeTypeChanged($event)"
            ></vectronic-header-field>
            @if (timeTypeFormControl.value === 'temporary') {
              <div>
                <vectronic-header-field
                  type="date"
                  label="Start date"
                  [control]="startDateFormControl"
                  (valueChange)="onStartDateChanged($event)"
                  [minDate]="MIN_DATE"
                  [maxDate]="MAX_DATE"
                ></vectronic-header-field>
                <vectronic-header-field
                  #endDateField
                  type="date"
                  label="End date"
                  [control]="endDateFormControl"
                  (valueChange)="onEndDateChanged($event)"
                  [minDate]="MIN_DATE"
                  [maxDate]="MAX_DATE"
                ></vectronic-header-field>
              </div>
            }
            <div>
              @if (endDateFormControl.hasError('isEndDateAfterStartDate')) {
                <mat-error> Please select end date after start date</mat-error>
              }
            </div>
          </vectronic-header-item>
          <vectronic-header-item
            label="Repeat Interval"
            headerTooltip="Rule rerun interval"
            [value]="getRepeatString()"
            [readonly]="readonly()"
          >
            <vectronic-header-field
              type="radio"
              [options]="REPEAT_INTERVAL_TYPE_OPTION"
              [control]="repeatIntervalTypeFormControl"
              (valueChange)="onRepeatIntervalChanged($event)"
            ></vectronic-header-field>
            @if (repeatIntervalTypeFormControl.value === 'advanced') {
              <div class="create-rule__item">
                <vectronic-header-field
                  class="create-rule__field"
                  label="Day"
                  type="number"
                  [control]="repeatIntervalDayFormControl"
                  (valueChange)="onRepeatIntervalDayChanged($event)"
                  [min]="0"
                ></vectronic-header-field>
                <vectronic-header-field
                  class="create-rule__field"
                  label="Hour"
                  type="number"
                  [control]="repeatIntervalHourFormControl"
                  (valueChange)="onRepeatIntervalHourChanged($event)"
                  [min]="0"
                  [max]="23"
                ></vectronic-header-field>
                <vectronic-header-field
                  class="create-rule__field"
                  label="Minute"
                  type="number"
                  [control]="repeatIntervalMinuteFormControl"
                  (valueChange)="onRepeatIntervalMinuteChanged($event)"
                  [min]="0"
                  [max]="59"
                ></vectronic-header-field>
              </div>
            }
          </vectronic-header-item>
        </vectronic-header-group>

        @if (scheduleService()?.config?.hasSkipCount) {
          <vectronic-header-group>
            <vectronic-header-item
              label="Skip Position"
              headerTooltip="Non-transmitted positions between two transmissions"
              [value]="getSkipString()"
              [readonly]="readonly()"
            >
              <vectronic-header-field
                type="radio"
                [options]="skipTypeOptions()"
                [control]="skipTypeFormControl"
                (valueChange)="onSkipPositionChanged($event)"
              ></vectronic-header-field>
              <div class="create-rule__item">
                @if (skipTypeFormControl.value === 'skip') {
                  <vectronic-header-field
                    class="create-rule__field"
                    label="Count"
                    type="number"
                    [control]="skipPositionCountFormControl"
                    (valueChange)="onSkipCountChanged($event)"
                    [min]="1"
                  ></vectronic-header-field>
                }
              </div>
            </vectronic-header-item>
            @if (
              skipPositionCountFormControl.hasError('min') ||
              skipPositionCountFormControl.hasError('max')
            ) {
              <mat-error> between 1 - {{ scheduleService().config.maxSkipCount }}</mat-error>
            }
          </vectronic-header-group>
        }

        @if (hasTransmissionCount()) {
          <vectronic-header-group [title]="'Transmission'" icon="functions">
            <vectronic-header-item
              label="Fixes per transmission"
              [value]="
                isNoCommunication() || transmissionTypeFormControl.value === 'no_transmission'
                  ? 'No Transmissions'
                  : scheduleService().fixPerTransmission$.value?.[index()] || 1
              "
              [readonly]="readonly() || isNoCommunication()"
            >
              <div class="create-rule__transmission">
                <mat-radio-group
                  class="create-rule__transmission-radio"
                  [formControl]="transmissionTypeFormControl"
                >
                  <mat-radio-button
                    class="create-rule__transmission-option"
                    value="no_transmission"
                    (change)="onTransmissionTypeChanged($event.value)"
                  >
                    No Transmissions
                  </mat-radio-button>
                  <mat-radio-button
                    class="create-rule__transmission-option"
                    value="count"
                    (change)="onTransmissionTypeChanged($event.value)"
                  >
                    Fixes per transmission
                  </mat-radio-button>
                </mat-radio-group>
                <vectronic-header-field
                  type="number"
                  [control]="transmissionFormControl"
                  (valueChange)="onTransmissionChanged($event)"
                  [min]="1"
                ></vectronic-header-field>
              </div>
            </vectronic-header-item>
          </vectronic-header-group>
        }
      } @else {
        <div class="create-rule__header-collapsed-list" (click)="onClickRule()">
          <span class="create-rule__header-collapsed-item">
            <mat-icon>timelapse</mat-icon>
            {{ getDurationString() }} </span
          ><span>|</span>
          <span class="create-rule__header-collapsed-item">
            <mat-icon>refresh</mat-icon>
            {{ getRepeatString() }}
          </span>
          @if (scheduleService().config.hasSkipCount) {
            <span>|</span>
            <span class="create-rule__header-collapsed-item">
              <mat-icon>skip_next</mat-icon>
              {{ getSkipString() }}
            </span>
          }
        </div>
      }
    </div>
  </mat-card-title>

  <mat-divider></mat-divider>

  <mat-card-content class="create-rule__content">
    <div class="create-rule__form">
      @if ((!rule().sequences || rule().sequences.length === 0) && !readonly()) {
        <div class="create-rule__sequence-empty">Please add a sequence!</div>
      }
      <div class="create-rule__sequence">
        @for (sequence of rule().sequences; let i = $index; track i) {
          <mat-card class="create-rule__sequence-card">
            <rc-sequence
              [sequenceIndex]="i"
              [ruleIndex]="index()"
              [fixRate]="sequence.fixRate"
              [duration]="sequence.duration"
              [offset]="sequence.offset"
              [periodLength]="rule().periodLength"
              [startDate]="rule().startTime"
              [skipPosition]="rule().skipCount"
              [isDeletable]="rule().sequences?.length > 1"
              (remove)="onRemoveSequence($event)"
              [isRuleExpanded]="scheduleService()?.isRuleExpanded?.[index()] || false"
              [scheduleService]="scheduleService()"
              [isCommunication]="scheduleService().config.hasCommunicationInterval"
              [readonly]="readonly()"
              [hasTransmissionCount]="hasTransmissionCount()"
              (clickSummary)="onClickRule()"
              [isBeacon]="scheduleService()?.scheduleType === 'VHF'"
            ></rc-sequence>
          </mat-card>
        }
      </div>
    </div>
  </mat-card-content>
  @if (!readonly()) {
    <div class="create-rule__action-buttons">
      <button
        mat-button
        class="create-rule__add-sequence"
        (click)="onClickAddFixRateRule()"
        [disabled]="!rule().periodLength"
        [attr.data-testid]="'add-sequence-button'"
      >
        <mat-icon color="accent">add</mat-icon>
        Add Sequence
      </button>
      <div [matTooltip]="isDeletable() ? 'Delete Rule' : 'Specify at least one rule'">
        <button
          mat-button
          [attr.data-testid]="'delete-rule-button'"
          (click)="onClickRemoveRule()"
          color="warn"
          [disabled]="!isDeletable()"
        >
          <mat-icon>delete</mat-icon>
          Remove Rule
        </button>
      </div>
    </div>
  }
</mat-card>
